import React from "react";
import useDisableIntercom from "@/hooks/useDisableIntercom";
import {
  Container,
  Wrapper,
  Strong,
  OL,
  LI,
  Heading,
  RomanList,
  GlobalCss,
  TableBox,
  TableHeader,
  TableData,
  Data,
  TableRow,
} from "./style";
import { Typography } from "@/foundation/Typography/V1";
import theme from "@/foundation/Theme";

export const LiveClassContent = (props) => {
  const { showHeader = false } = props || {};
  return (
    <Container flexDirection={"column"}>
      {showHeader && (
        <Typography
          fontFamily={"var(--font-500)"}
          color={theme.colors.gray_100}
          variant="heading1"
        >
          Live Class Policy
        </Typography>
      )}
      <Wrapper flexDirection={"column"}>
        <Typography
          variant="paragraph2"
          fontFamily={"var(--font-400)"}
          color={theme.colors.gray_100}
        >
          Welcome to Shyft! We are thrilled you've taken this crucial step
          towards building a healthier body and mind for yourself. By signing up
          for your chosen program, you are agreeing to the following terms:
        </Typography>
        <OL pl={"0px"}>
          <LI>
            <Heading variant="paragraph2" color={theme.colors.gray_100}>
              <Strong>Joining Classes on Time</Strong>
            </Heading>
            <OL>
              <LI>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                >
                  You can join your scheduled classes 5 minutes before the
                  scheduled class start time. Joining a class gets auto-disabled
                  10 minutes after the scheduled start time, and you will not be
                  able to join the class after 10 minutes.
                </Typography>
              </LI>
            </OL>
          </LI>
          <LI>
            <Heading variant="paragraph2" color={theme.colors.gray_100}>
              <Strong>Missing Classes</Strong>
            </Heading>
            <OL mb={"25px"}>
              <LI>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                >
                  Every program at Shyft allows you to 'carry forward' up to 25%
                  of your classes* for free to account for unexpected
                  circumstances such as sickness including but not limited to
                  COVID, family emergencies, or last-minute work or personal
                  commitments. A carry forward happens if you miss a class for
                  any reason. A carry forward is when a class gets added to the
                  end of your pack automatically, in lieu of missed classes. The
                  Carry forward allowance depends on your purchased pack.
                  Details are given below:
                </Typography>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                >
                  Any class that is carried forward
                </Typography>
              </LI>
              <OL>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                >
                  Please note:
                </Typography>
                <RomanList>
                  Classes 'carried forward' are added back to your pack
                  automatically
                </RomanList>
                <RomanList>
                  You can see both the used, as well as availed carried forward
                  classes in both the app and the website
                </RomanList>
              </OL>
              <TableBox my="16px">
                <TableHeader>
                  <Data variant="paragraph2" fontFamily="var(--font-700)">
                    Pack Details
                  </Data>
                  <Data variant="paragraph2" fontFamily="var(--font-700)">
                    Carry-Forwards Allowed
                  </Data>
                </TableHeader>
                <TableData>
                  <TableRow>
                    <Data variant="paragraph2">8 class-pack</Data>
                    <Data variant="paragraph2">2 classes</Data>
                  </TableRow>
                  <TableRow>
                    <Data variant="paragraph2">12 class-pack</Data>
                    <Data variant="paragraph2">3 classes</Data>
                  </TableRow>
                  <TableRow>
                    <Data variant="paragraph2">36 class-pack</Data>
                    <Data variant="paragraph2">12 classes</Data>
                  </TableRow>
                  <TableRow>
                    <Data variant="paragraph2">72 class-pack</Data>
                    <Data variant="paragraph2">24 classes</Data>
                  </TableRow>
                  <TableRow>
                    <Data variant="paragraph2">144 class-pack</Data>
                    <Data variant="paragraph2">48 classes</Data>
                  </TableRow>
                </TableData>
              </TableBox>
            </OL>
          </LI>
          <LI>
            <Heading
              mb={"5px !important"}
              variant="paragraph2"
              color={theme.colors.gray_100}
            >
              <Strong>Class Start Date is Final and Binding</Strong>
            </Heading>
            <OL mb={"25px"}>
              <LI>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                >
                  Your chosen start date is final and binding. It can not be
                  altered, even if you have not yet started your pack.
                </Typography>
              </LI>
            </OL>
          </LI>
          <LI>
            <Heading
              mb={"5px !important"}
              variant="paragraph2"
              color={theme.colors.gray_100}
            >
              <Strong>Refunds are Not Possible</Strong>
            </Heading>
            <OL mb={"25px"}>
              <LI>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                >
                  All programs sold are final, and non-refundable
                </Typography>
              </LI>
            </OL>
          </LI>
          <LI>
            <Heading
              mb={"5px !important"}
              variant="paragraph2"
              color={theme.colors.gray_100}
            >
              <Strong>Marking Attendance</Strong>
            </Heading>
            <OL>
              <LI>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                >
                  As soon as you join your class, your attendance is
                  automatically marked in the system, and you do not need to
                  manually inform or update anyone.
                </Typography>
              </LI>
            </OL>
          </LI>
        </OL>
      </Wrapper>
      <GlobalCss />
    </Container>
  );
};
function LiveClassPage() {
  useDisableIntercom();

  return <LiveClassContent />;
}
export default LiveClassPage;
